import template from './swag-cms-extensions-form-editor-settings-field-type-text.html.twig';

export default {
    template,
    computed: {
        placeholder: {
            set(newPlaceholder) {
                Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldProperty(
                    this.field.id,
                    'placeholder',
                    newPlaceholder,
                );
            },
            get() {
                return this.field.placeholder;
            },
        },
    },
}
